import type {IssueViewerSecondaryViewServerQueryQuery} from '@github-ui/server-persisted-queries/types/IssueViewerSecondaryViewServerQuery'

import {LABELS} from '../constants/labels'
import styles from './MarkdownLastEditedBy.module.css'

type IssueSecondaryNode = NonNullable<NonNullable<IssueViewerSecondaryViewServerQueryQuery['repository']>['issue']>

type LastUserContentEditEditor = NonNullable<NonNullable<IssueSecondaryNode['lastUserContentEdit']>['editor']>

export type MarkdownLastEditedByFragment = {
  readonly viewerCanReadUserContentEdits: IssueSecondaryNode['viewerCanReadUserContentEdits']
  readonly lastUserContentEdit: {
    readonly editor: Pick<LastUserContentEditEditor, 'login'> | null
  } | null
}

type MarkdownLastEditedByProps = {
  editInformation?: MarkdownLastEditedByFragment
}

export function MarkdownLastEditedBy({editInformation: data}: MarkdownLastEditedByProps) {
  if (!data || !data.viewerCanReadUserContentEdits || !data.lastUserContentEdit || !data.lastUserContentEdit.editor) {
    return null
  }

  const {login} = data.lastUserContentEdit.editor

  return (
    <span className={styles.lastEditInfoContainer}>
      {`${LABELS.editHistory.editedBy} `}
      <span className={styles.editorLogin}>{login}</span>
    </span>
  )
}
